import React, { Component } from "react";
import Overall2018 from './201805Data.json';
import January2018 from "./JanuaryData.json";
import February2018 from "./FebruaryData.json";
import March2018 from "./MarchData.json";
import April2018 from "./AprilData.json";
import May2018 from "./MayData.json";

class RankingRows extends Component {

  render() {

  var leaderdata = [];

  if (this.props.data === "Overall2018"){
    leaderdata = Overall2018;
  } else if (this.props.data === "January2018") {
    leaderdata = January2018;
  } else if (this.props.data === "February2018") {
    leaderdata = February2018;
  } else if (this.props.data === "March2018") {
    leaderdata = March2018;
  } else if (this.props.data === "April2018") {
    leaderdata = April2018;
  } else if (this.props.data === "May2018") {
    leaderdata = May2018;
  }


  var counter = 0;
    return (
      leaderdata.map(function(player, i){
        counter++;
        return (
          <tr>
            <td>{counter}</td>
            <td>{player.DisplayName.toUpperCase() }</td>
            <td>{player.StatValue}</td>
          </tr>
        )

      })
    );
  }
}

export default RankingRows;



// WEBPACK FOOTER //
// ./src/LeaderBoard/RankingRows.js